module.exports = __webpack_public_path__ + "img/dianhua.b303a620.svg";